import * as React from "react";
import { FC } from "react";
import { PopupBody, PopupHeader, Popup, PopupFooter } from "./Popup";
import { useAppContext } from "../Contexts/AppContext";
import { CloseButton } from "../Elements/CloseButton";
import { useRegistrationContext } from "../Contexts/RegistrationContext";

export const HelpPopup: FC = () => {
    const { isMobile } = useAppContext();
    const { setDrawingInfoVisible } = useRegistrationContext();

    const text1 = "Atzīmējiet kartē plānoto darbu vietu.";
    const text2 = "Interesējošo kartes apgabalu iespējams pietuvināt, meklētājā norādot kadastra numuru.";

    return (
        <Popup id={"help-popup"} sameContainer={true} isMobile={false} hasBackdrop={true} className={"relative"}>
            <PopupHeader isMobile={isMobile}>
                {!isMobile && <div>Iezīmēt plānoto darbu vietu</div>}
                <CloseButton onClose={() => setDrawingInfoVisible(false)}></CloseButton>
            </PopupHeader>
            <PopupBody isMobile={isMobile}>
                <div>{text1}</div>
                <div>{text2}</div>
            </PopupBody>
            <PopupFooter isMobile={isMobile}></PopupFooter>
        </Popup>
    );
};
